import logo from "../../assets/90.png";
import React, { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import "./navigation.scss";
// import logo from "../../assets/merxologo.png";
// import TranslateWidget from './GoogleTranslateWidget';
import Dropdown from "react-bootstrap/Dropdown";
import MenuIcon from "@mui/icons-material/Menu";


const Navigation = () => {
  const [isDropdownOpen, setDropdownOpen] = useState(false);

  const toggleDropdown = () => {
    setDropdownOpen(!isDropdownOpen);
  };

  return (
    <div className="navigation">
      <div className="first flex">
        <div className="nav-logo">
          <Link to="/">
            <img className="brand-logo" src={logo} alt="" />
          </Link>
        </div>
        <div className="nav-links flex">
          <span className="nav-link">
            {" "}
            <Link to="/about-us">About us</Link>{" "}
          </span>

          <Dropdown data-bs-theme="dark">
            <Dropdown.Toggle
              id="dropdown-button-dark-example1"
              variant="secondary"
              className="nav-link"
            >
              Mirror Trading
            </Dropdown.Toggle>

            <Dropdown.Menu>
              <Dropdown.Item href="/options-trading">
                Options copy trading
              </Dropdown.Item>
              <Dropdown.Item href="/advanced-trading">
                Advanced trading account above PDT
              </Dropdown.Item>
              <Dropdown.Item href="/live-trading">
                Live trading interface
              </Dropdown.Item>
            </Dropdown.Menu>
          </Dropdown>

          <Dropdown data-bs-theme="dark">
            <Dropdown.Toggle
              id="dropdown-button-dark-example1"
              variant="secondary"
            >
              Trading Categories
            </Dropdown.Toggle>

            <Dropdown.Menu>
              <Dropdown.Item href="/futures">Futures Trading</Dropdown.Item>
              <Dropdown.Item href="/stock">Stock Trading</Dropdown.Item>
              <Dropdown.Item href="/forex">Forex Trading</Dropdown.Item>
              <Dropdown.Item href="/commodites">
                Commodity stock Trading
              </Dropdown.Item>
            </Dropdown.Menu>
          </Dropdown>
          <Link to="/insight">
            <span className="nav-link">Insight</span>
          </Link>
          <Link to="/software">
            <span className="nav-link">Software</span>
          </Link>
        </div>
      </div>

      <div className="second flex">
        {/* <TranslateWidget /> */}

        <Link to="/login">
          <button className="log ">Login</button>
        </Link>
        <div className="">
          <button onClick={toggleDropdown} className="mn-btn d-lg-none">
            {" "}
            <MenuIcon />{" "}
          </button>
          {isDropdownOpen && (
            <div className="nav-links coll">
              <span className="nav-link">
                {" "}
                <Link to="/about-us">About us</Link>{" "}
              </span>
              <Dropdown data-bs-theme="dark">
                <Dropdown.Toggle
                  id="dropdown-button-dark-example1"
                  variant="secondary"
                >
                  Mirror Trading
                </Dropdown.Toggle>

                <Dropdown.Menu>
                  <Dropdown.Item href="/futures">Futures Trading</Dropdown.Item>
                  <Dropdown.Item href="/stock">Stock Trading</Dropdown.Item>
                  <Dropdown.Item href="/forex">Forex Trading</Dropdown.Item>
                  <Dropdown.Item href="/commodites">
                    Commodity stock Trading
                  </Dropdown.Item>
                </Dropdown.Menu>
              </Dropdown>

              <Dropdown data-bs-theme="dark">
                <Dropdown.Toggle
                  id="dropdown-button-dark-example1"
                  variant="secondary"
                >
                  Trading Categories
                </Dropdown.Toggle>

                <Dropdown.Menu>
                  <Dropdown.Item href="/futures">Futures Trading</Dropdown.Item>
                  <Dropdown.Item href="/stock">Stock Trading</Dropdown.Item>
                  <Dropdown.Item href="/forex">Forex Trading</Dropdown.Item>
                  <Dropdown.Item href="/commodites">
                    Commodity stock Trading
                  </Dropdown.Item>
                </Dropdown.Menu>
              </Dropdown>
              <Link to="/insight">
                <span className="nav-link">Insight</span>
              </Link>
              <Link to="/software">
                <span className="nav-link">Software</span>
              </Link>
            </div>
          )}
        </div>
      </div>
    </div>
  );
};

export default Navigation;

// import React, { useState } from 'react';
// import "./navigation.scss";

// const Navigation = () => {
//     const [isMenuOpen, setMenuOpen] = useState(false);

//     // Toggle function for mobile navigation
//     const handleMenuToggle = () => {
//         setMenuOpen(!isMenuOpen);
//     };

//     return (
//         <header className=''>

//             <div id="site-header-wrap"  >
//                 <div id="site-logo">
//                     <a href="/" title="Home" className="main-logo">
//                         <img src={logo} alt="Logo" width="184" height="40" />
//                     </a>
//                 </div>
//                 <div className="mobile-button" onClick={handleMenuToggle}>
//                     <span></span> {/* Hamburger Icon */}
//                 </div>
//                 <nav id="main-nav" className={`main-nav ${isMenuOpen ? 'menu-open' : ''}`} style={{ right: 0 }}>
//                     <ul id="menu-primary-menu" className="menu">
//                         <li className="menu-item"><a href="/">HOME</a></li>
//                         <li className="menu-item"><a href="/about">ABOUT</a></li>
//                         <li className="menu-item menu-item-has-children">
//                             <a href="#">SERVICES</a>
//                             <ul className="sub-menu">
//                                 <li className="menu-item"><a href="/cryptocurrency">CRYPTO TRADING</a></li>
//                                 <li className="menu-item"><a href="/stocks">STOCKS TRADING</a></li>
//                                 <li className="menu-item"><a href="/real-estate">REAL ESTATE INVESTMENTS</a></li>
//                                 <li className="menu-item"><a href="/energy-and-power">ENERGY AND POWER</a></li>
//                                 <li className="menu-item"><a href="/natural-resources">NATURAL RESOURCES</a></li>
//                                 <li className="menu-item"><a href="/gold">GOLD INVESTMENTS</a></li>
//                                 <li className="menu-item"><a href="/oil-and-gas">OIL AND GAS</a></li>
//                                 <li className="menu-item"><a href="/forex">FOREX AND OPTIONS</a></li>
//                                 <li className="menu-item"><a href="/retirement">RETIREMENT INCOME</a></li>
//                             </ul>
//                         </li>
//                         <li className="menu-item"><a href="/copy-trading">COPY TRADING</a></li>
//                         <li className="menu-item"><a href="/insight">INSIGHT</a></li>
//                         <li className="menu-item"><a href="/software">SOFTWARE</a></li>
//                         <li className="menu-item"><button onClick={() => console.log("Login Clicked")} className="menu-item-login">LOGIN</button></li>
//                         <li className="menu-item"><button onClick={() => console.log("Register Clicked")} className="menu-item-register uael_btn__blink">REGISTER</button></li>
//                     </ul>
//                 </nav>
//             </div>
//         </header>
//     );
// };

// export default Navigation;
